import building from 'plugins/i18n/entity/building.en.ts'
import unit from 'plugins/i18n/entity/unit.en.ts'

const meter = {
	name: 'Meter Readings',
	icon: 'fas fa-tachometer-alt',
	fields: {
		hp_id: 'Meter number',
		device_type: {
			description: 'Type',
		},
		installation_place: 'Location',
		removed_at: 'Removed at',
		last_accepted_level: {
			value: 'Last value',
			read_off_at: 'Date of last value',
		},
		building: {
			...building.fields,
		},
		unit: {
			...unit.fields,
		},
	},
}

export default meter
